export default __webpack_public_path__ + "static/media/zena-testimony-image-1.e6f4330b.png";